angular.module('zc.zenclerkS')
  .controller('ZcsHomeController', ZcsHomeController);

ZcsHomeController.$inject = ['$location', '$state', 'Agency', 'Devise', 'agencies', 'projects'];
function ZcsHomeController($location, $state, Agency, Devise, agencies, projects) {
  const vm = this;

  vm.$onInit = () => {
    // add a same filter field for agencies and projects
    _.each(agencies, a => {
      a._isAgency = true;
      a._isTerminated = false;
      a._isInstalled = true;
      a._filterText = a.name + ' ' + a.title;
    });
    _.each(projects, p => {
      p._filterText = p.apikey + ' ' + p.title + ' ' + p.base_url + ' ' + p.company_name;
      p._isTerminated = p.is_terminated;
      p._isInstalled = false;
      if(p.installed_at) {
        p._isInstalled = true;
      }
      if(p.is_demo) {
        p._isInstalled = true;
      }
    });

    // variables
    vm.projects = [];
    vm.demoProjects = [];
    vm.testProjects = [];
    vm.agencies = agencies;
    vm.all = agencies.concat(projects);
    vm.menu = $location.search().type || 'all';
    vm.items = vm[vm.menu];
    vm.filterInput = '';
    vm.limit = '50';
    vm.showTerminatedOnly = false;
    vm.showNotInstalledOnly = false;

    // actions
    vm.getAgencyColor = Agency.getAgencyColor;
    vm.signOut = Devise.signOut;
    vm.isNew = isNew;
    vm.selectType = selectType;
    vm.goTo = goTo;

    for(let project of projects) {
      if(project.is_demo) {
        vm.demoProjects.push(project);
      } else if(project.is_test) {
        vm.testProjects.push(project);
      } else if(project.apikey) {
        vm.projects.push(project);
      }
    }
  };

  function selectType(type) {
    if(type === vm.menu) {
      vm.sortReverse = !vm.sortReverse;
    } else {
      vm.sortReverse = false;
    }

    vm.menu = type;
    vm.items = vm[type];
    if(type === 'all') {
      $location.search('type', null);
    } else {
      $location.search('type', type);
    }
  }

  function goTo(item) {
    if(item.apikey) {
      $state.go('zenclerkS.project.dashboard', { apikey: item.apikey });
    } else {
      $state.go('zenclerkS.agency.home', { agencyName: item.name });
    }
  }

  function isNew(createdAt) {
    if(moment().diff(moment(createdAt), 'days') < 15) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/home/home.controller.js